import React from "react";
import JobManagement from "../components/job/JobManagement";

const Jobs = () => {
  // istanbul ignore next
  return (
    <div className="custom-container">
      <div className="custom-inner">
        <JobManagement />
      </div>
    </div>
  );
};

export default Jobs;